<script>
import { mapActions, mapState } from 'pinia';

import { useUserStore } from '@store/useUserStore.js';
import { useCommentStore } from '@store/useCommentStore.js';
import { comment } from '@resources/js/api/comments';

export default {
  name: 'CpMessageAsComment',
  components: {
    CpButton: require('@resources/js/button').default,
    CpTextInput: require('@resources/js/inputs/text').default,
  },
  directives: {
    margin: require('@resources/js/directives/margins').margin,
  },
  props: {
    emailBody: { type: String, default: null },
    lawmakerName: { type: String, default: null },
    lobbyId: { type: [Number, String], default: null },
    postId: { type: [Number, String], default: null },
    postType: { type: String, default: null },
    handleDialog: { type: Function, default: () => {} },
  },
  data() {
    return {
      loading: false,
      comment: `I have sent this message to ${this.lawmakerName}:\n\n"${this.emailBody}"`,
      lobbySuccess: false,
      lobbyError: false,
    };
  },
  computed: {
    ...mapState(useUserStore, ['userProfileData']),
  },
  methods: {
    ...mapActions(useCommentStore, ['notifyCommentCreated']),
    async handleSubmit() {
      this.loading = true;
      const commentData = { comment: this.comment, lobby_id: this.lobbyId, gif: null, image: null, video: null };
      await comment(this.postId, this.postType, { ...commentData, reply_id: null })
        .then(() => {
          this.notifyCommentCreated({ type: this.postType, id: this.postId });
          this.lobbySuccess = true;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.lobbyError = true;
          console.warn(error);
        });
    },
  },
};
</script>

<template>
  <div v-if="!lobbySuccess && !lobbyError" class="messageContainer">
    <i class="fal fa-comment-dots fa-4x primary-color text-center"></i>
    <h2 class="heading-2 black-color text-center">Share Your Message As a Comment</h2>
    <p class="body neutral-2-color text-center">Edit your message below and share it with the community</p>
    <CpTextInput multiline block v-model="comment" :rows="8" />
    <div class="box-buttons">
      <CpButton @click="handleDialog" class="btn-lobby" block>CANCEL</CpButton>
      <CpButton @click="handleSubmit" class="btn-lobby" block primary :loading="loading" :disabled="loading || !comment">POST</CpButton>
    </div>
  </div>
  <div v-else-if="lobbySuccess" class="success-container">
    <div class="success-icon">
      <i class="fas fa-check-circle success-color fa-3x"></i>
    </div>
    <h3 class="subhead black-color text-center">Success, {{ userProfileData?.first_name }}! Your message has been sent</h3>
    <p class="body neutral-2-color text-center" v-margin="1">The comment was successfully sent.</p>
    <CpButton primary @click="handleDialog" block>Ok</CpButton>
  </div>
  <div v-else-if="lobbyError">
    <i class="fal fa-times close-icon" @click="handleDialog"></i>
    <div class="error-icon-container">
      <i class="fas fa-times error-icon"></i>
    </div>
    <p class="heading-2 black-color text-center">An error has occurred!</p>
  </div>
</template>

<style scoped>
.messageContainer {
  display: flex;
  flex-direction: column;
}
.btn-lobby {
  margin: 5px;
}
.box-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.success-container {
  padding: 20px 0;
}
.success-icon {
  display: flex;
  justify-content: center;
}
.close-icon {
  top: 5px;
  right: 5px;
  position: absolute;
  cursor: pointer;
}
.error-icon-container {
  display: flex;
  justify-content: center;
}
</style>
